module.exports = __webpack_public_path__ + "img/home_zhineng_dengpao.bd4dc063.png";